import {fbLink, instaLink, twitterLink, tripLink} from '../Shared/Links'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import XIcon from '@mui/icons-material/X';

const social = (props) => {
  return (
    <ul id="social-links" className={`socialList ${props.where ?? 'uni'} ${props.addClass ?? 'std'}`}>
      <li className="item fb">
        <a href={fbLink} target="_blank" rel="noopener noreferrer">
          <span aria-label="Villaggio Grille Facebook Link"><FacebookIcon /></span>
        </a>
      </li>
      <li className="item ig">
        <a href={instaLink} target="_blank" rel="noopener noreferrer">
          <span aria-label="Villaggio Grille Instagram Link"><InstagramIcon /></span>
        </a>
      </li>
      <li className="item tw">
        <a href={twitterLink} target="_blank" rel="noopener noreferrer">
          <span aria-label="Villaggio Grille Twitter Link"><XIcon /></span>
        </a>
      </li>
      {props.showTrip && (
        <li className="item trip adv">
          <div id="TA_socialButtonBubbles315" className="TA_socialButtonBubbles">
            <ul id="RyzN41p0Q8j" className="TA_links r04oU5">
              <li id="qY8coROITv" className="UMF8YEGBm">
                <a target="_blank" rel="noreferrer" href={tripLink}>
                  <img src="http://www.tripadvisor.com/img/cdsi/img2/branding/socialWidget/20x20_green-21693-2.png" alt="Trip advisor graphic" />
                </a>
              </li>
            </ul>
          </div>
          <script src="http://www.jscache.com/wejs?wtype=socialButtonBubbles&amp;uniq=315&amp;locationId=1074736&amp;color=green&amp;size=sm&amp;lang=en_US&amp;display_version=2"></script>
        </li>      
      )}
    </ul>
  )
}
export default social